import { useTranslation } from '@mukil/i18n';
import type { TwoFactorErrorKind } from '../../lib/auth/two_factor_logic.js';

/**
 * The one place a two-step failure becomes words. Every case is a literal
 * `t()` call (not a computed key) so each message is visible to the i18n
 * coverage and orphan checks.
 */
export function TwoFactorError({
  kind,
}: {
  kind: TwoFactorErrorKind;
}): React.JSX.Element {
  const { t } = useTranslation('wp');
  return (
    <p role="alert" className="text-[13px] text-[var(--color-danger)]">
      {twoFactorErrorCopy(kind, t)}
    </p>
  );
}

function twoFactorErrorCopy(
  kind: TwoFactorErrorKind,
  t: (key: string) => string,
): string {
  switch (kind) {
    case 'invalid_code':
      return t('two_factor.error_invalid_code');
    case 'expired':
      return t('two_factor.error_expired');
    case 'too_many_attempts':
      return t('two_factor.error_too_many_attempts');
    case 'wrong_password':
      return t('two_factor.error_wrong_password');
    case 'required_by_company':
      return t('two_factor.error_required_by_company');
    case 'enable_self_first':
      return t('two_factor.error_enable_self_first');
    case 'network':
      return t('auth.network_error');
    case 'unknown':
      return t('auth.unknown_error');
  }
}
